export var csvEscape = function (value) {
    var text = value.replace(/"/g, '""');
    return "\"".concat(text, "\"");
};
export var downloadCsv = function (filename, rows) {
    var content = rows.map(function (row) { return row.map(csvEscape).join(','); }).join('\n');
    var blob = new Blob(["\uFEFF".concat(content)], { type: 'text/csv;charset=utf-8;' });
    var url = URL.createObjectURL(blob);
    var link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.click();
    URL.revokeObjectURL(url);
};
export var todayStamp = function () { return new Date().toISOString().slice(0, 10); };
